const backend_url = process.env.REACT_APP_IMAGE_BASE_URL;

export const user_profile_image_url     = `${backend_url}/users/`;
export const patients_attachments_url   =  `${backend_url}patient/attachments`;
export const lab_report_attachments_url =  `${backend_url}lab-report/attachments`;
export const banner_image_url           = `${backend_url}/banners/`;
export const blog_category_image_url    = `${backend_url}/blog-categories/`;
export const brand_image_url            = `${backend_url}/brands/`;
export const category_image_url         = `${backend_url}/categories/`;
export const product_image_url          = `${backend_url}/products/`;
export const blog_image_url             = `${backend_url}/blogs/`;
export const setting_image_url          = `${backend_url}/settings/`;